import React from 'react';
import {Button, Icon, Table, Form, Header, Popup, Segment, Loader, Grid} from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import {
    fetchAcademicYears,
    fetchStudentStatuses,
    fetchStudyCycle,
    fetchStudyType,
    fetchStudyYears
} from '../../Lookups/util';


import SearchTableData from "../../util/SearchTableData";
import PaginationFront from "../../util/PaginationFront";
import ReactExport from 'react-data-export';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const obj = {};

const NoDataMessage = () => <p>Nema studenata.</p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;


export default class GradStudents extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            filterData: [],
            academicYears: [],
            academicYearsClear: [],
            academicYear: '',
            studyPrograms: [],
            studyProgramBasics: [],
            studyProgramBasicsAll: [],
            studyProgramBasicId: null,
            student: null,

            loading: true,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: [],
            excelData: [],

            unsa: !!((localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu')),


        };
        this.filter = this.filter.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        let obj = {};
        axios.post(this.state.unsa ? 'study-programs/basic/all' : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.unsa ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                console.log('studyProgramBasics', studyProgramBasics);

                this.setState({ studyProgramBasics, studyProgramBasicsAll: studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });

        axios.get('/study-program-semesters')
            .then(res => {
                let studyProgramSemesters = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    studyProgramSemesters, studyProgramSemestersAll: studyProgramSemesters
                });
            });

        axios.all([fetchAcademicYears(), fetchStudyCycle(), fetchStudyType(), fetchStudentStatuses(), fetchStudyYears()])
            .then(axios.spread((yearsRes, studyCycleRes, studyTypesRes, studentStatusesRes, studyYearsRes) => {
                const academicYears = yearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                })).reverse();

                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                const studyTypes = studyTypesRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                let studentStatuses = studentStatusesRes.data.filter(e=> e._key == 'regular' || e._key == 'exchange' || e._key == 'guest' || e._key == 'grad_again').map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }

                const studyYears = studyYearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));

                this.setState({
                    studyCycles, studyTypes, studentStatuses, studyYears, academicYears
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch organizationalUnits, studyCycles, languages or academicYears');
            });
    }

    handleInputChange(event, { name, value }) {
        if (value === '') {
            this.setState({
                [name]: null
            });
        }
        this.setState({
            [name]: value
        });

        if (name === 'studyCycleId') {
            if (value === null) this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll });
            this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll.filter(el => el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].id === value : null) });
        }

        if (name === 'studyCycleId' && value === '') { this.setState({ studyCycleId: null, studyProgramBasics: this.state.studyProgramBasicsAll }); }
    }

    filter() {
        this.setState({ loaded: false, results: [], activePage: 1 });
        let obj = {
            studyCycleId: this.state.studyCycleId,
            studyProgramBasicId: this.state.studyProgramBasicId,
        };

        if(!this.state.unsa){
        axios.post(`students/filter-grad-students/${this.state.academicYearId}`, { ...obj })
            .then(res => {
                this.setState({ data: res.data.map(el=>({...el, department: el.departmentsSPOU.length  ? el.departmentsSPOU[0].organizationalUnitName : ''})), loaded: true });
                const excelData = res.data.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.index},
                    { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.studyCycleName},
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                console.log('Failed to fetch students');
            });
    }
        else{
            axios.post(`reports/grad-students-count/${this.state.academicYearId}/`, { ...obj })
                .then(res => {
                    console.log('res', res.data);
                    this.setState({
                        data: res.data, loaded: true,
                        excelData: res.data.map(el => ([
                            { value: el.organizationalUnitName},
                            { value: el.numberOfStudents},
                        ]))
                    });
                });
        }
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }


    getResults(results) {
        if(results.length === 0){
            this.setState({ excelData: this.state.unsa ?  this.state.data.map(el => ([
                        { value: el.organizationalUnitName},
                        { value: el.numberOfStudents},
                    ]))
                    :  this.state.data.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.index},
                        { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.studyCycleName},
                    ]))});
        }else{
            this.setState({ results, excelData: this.state.unsa ?  results.map(el => ([
                        { value: el.organizationalUnitName},
                        { value: el.numberOfStudents},
                    ]))
                    :  results.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.index},
                        { value: el.departmentsSPOU.length ? el.departmentsSPOU[0].organizationalUnitName: ''},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.studyCycleName},
                    ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    render() {

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 200 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'Plan i program', width: { wpx: 300 } },
                    { title: 'Ciklus studija', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];

        const multiDataSet1 = [
            {
                columns: [
                    { title: 'Organizaciona jedinica', width: { wpx: 300 } },
                    { title: 'Broj studenata', width: { wpx: 100 } },
                ],
                data: this.state.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                <Form>
                    {/*{this.state.unsa &&  <Form.Group widths="equal">*/}
                    {/*    <Form.Field>*/}
                    {/*        <Form.Dropdown*/}
                    {/*            clearable*/}
                    {/*            label="Organizaciona jedinica"*/}
                    {/*            placeholder="Organizaciona jedinica"*/}
                    {/*            value={this.state.organizationalUnitId}*/}
                    {/*            onChange={this.handleInputChange}*/}
                    {/*            name="organizationalUnitId"*/}
                    {/*            options={this.props.organizationalUnits}*/}
                    {/*            search*/}
                    {/*            fluid*/}
                    {/*            required*/}
                    {/*            selection*/}
                    {/*            error={this.state.organizationalUnitEntityError}*/}
                    {/*        />*/}
                    {/*    </Form.Field>*/}
                    {/*    <Form.Field/>*/}
                    {/*    <Form.Field/>*/}
                    {/*</Form.Group>}*/}
                    <Form.Group widths="equal">
                        <Form.Field>
                            <Form.Dropdown
                                required
                                label="Akademska godina"
                                clearable={this.get}
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYearId}
                                onChange={this.handleInputChange}
                                name="academicYearId"
                                options={this.state.academicYears}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        <Form.Field>
                            <Form.Dropdown
                                label="Ciklus studija"
                                clearable
                                placeholder="Odaberite ciklus"
                                options={this.state.studyCycles}
                                onChange={this.handleInputChange}
                                name="studyCycleId"
                                value={this.state.studyCycleId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <Form.Dropdown
                                label="Studijski program"
                                clearable
                                placeholder="Odaberite studijski program"
                                options={this.state.studyProgramBasics}
                                onChange={this.handleInputChange}
                                name="studyProgramBasicId"
                                value={this.state.studyProgramBasicId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>


                    </Form.Group>


                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button color="blue" floated="right" onClick={this.filter}>Filtriraj
                    </Button>
                </Form>

                <br /><br /><br />
                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    this.state.loaded &&
                    <div>

                        {this.state.data.length ? <Table celled selectable compact>

                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={this.state.unsa ? 2 : 15} >
                                    <Grid columns={2} stackable>

                                        <Grid.Column width={14}>
                                            <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['organizationalUnitName', 'firstName', 'lastName', 'index', 'studyProgramName', 'studyProgramBasicName', 'department', 'studyCycleName']} />
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign={'center'}>
                                            <ExcelFile filename="Spisak apsolvenata" element={<Popup
                                                trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                    <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                    <Button.Content visible>
                                                        Excel
                                                    </Button.Content>
                                                </Button>}
                                                content="Preuzmi spisak u Excel-u"
                                                hideOnScroll
                                                position="top center"
                                            />}>
                                                <ExcelSheet dataSet={this.state.unsa ? multiDataSet1 : multiDataSet} name="Studenti" />
                                            </ExcelFile>
                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                                {/*<Table.HeaderCell colSpan={15} >*/}
                                {/*        <span> {this.state.data && <ExportReactCSV color="green" csvData={this.state.data} headers={headersForExport} floated="right" fileName="Spisak apsolvenata" />}*/}
                                {/*            <SearchTableData data={this.state.showFiltersOnButton ? this.state.filterData : this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'studyProgramName', 'studyProgramBasicName', 'department', 'studyCycleName']} />*/}
                                {/*        </span>*/}
                                {/*</Table.HeaderCell>*/}
                            </Table.Row>
                            {this.state.unsa ?
                                <Table.Row>
                                    <Table.HeaderCell>Organizaciona jedinica</Table.HeaderCell>
                                    <Table.HeaderCell> Broj studenata </Table.HeaderCell>

                                </Table.Row>
                                : <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Prezime i ime</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Index</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Odsjek</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Studijski program</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Ciklus studija</Table.HeaderCell>
                            </Table.Row>}
                        </Table.Header>
                            {this.state.unsa ?
                                <Table.Body> {currentPosts.map((el, index) =>
                                    (<Table.Row key={el.id}>
                                        <Table.Cell verticalAlign="middle" > {el.organizationalUnitName}</Table.Cell>
                                        <Table.Cell verticalAlign="middle" > {el.numberOfStudents}</Table.Cell>

                                    </Table.Row>))}
                                </Table.Body> :
                        <Table.Body> {currentPosts.map((el, index) =>
                            (<Table.Row key={index}>
                                    <Table.Cell verticalAlign="middle" width={1}>
                                        {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {el.lastName} {el.firstName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle">
                                        {el.index}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {el.departmentsSPOU.map(e => <div>{e.organizationalUnitName} <br /></div>)}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                    </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle">
                                        {el.studyCycleName}
                                    </Table.Cell>
                                </Table.Row>))}
                        </Table.Body>}
                    </Table>
                    : <NoDataMessage />
                }
                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </div>}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/GradStudents.js